import iconsList from "../components/ui/icons/iconsList";

export const StageType = {
  REGISTRATION: 'Registration',
  TRAINING: 'Training',
  ADVANCED: 'Advanced',
  EMERGENCY_INTRODUCTION: 'EmergencyIntroduction',
  SCHOOL_COMPETITION: 'SchoolCompetition',
  FINALISTS: 'FinalistsAnnouncement',
  FINAL_EVENT: 'VirtualFinalEvent',
}

export const StageStyleMap = {
  [StageType.REGISTRATION]: {
    text: "registrationStep",
    hebrewDate: "registrationStepHebrewDate",
    icon: iconsList.registration
  },
  [StageType.TRAINING]: {
    text: "trainingStep",
    hebrewDate: "trainingStepHebrewDate",
    icon: iconsList.training
  },
  [StageType.ADVANCED]: {
    text: "advancedStep",
    hebrewDate: "advancedStepHebrewDate",
    icon: iconsList.advanced
  },
  [StageType.EMERGENCY_INTRODUCTION]: {
    text: "emergencyIntroductionStep",
    hebrewDate: "emergencyIntroductionStepHebrewDate",
    icon: iconsList.training
  },
  [StageType.SCHOOL_COMPETITION]: {
    text: "competitionStep",
    hebrewDate: "competitionStepHebrewDate",
    icon: iconsList.competition
  },
  [StageType.FINALISTS]: {
    text: "finalistsStep",
    hebrewDate: "finalistsStepHebrewDate",
    icon: iconsList.finalists,
  },
  [StageType.FINAL_EVENT]: {
    text: "virtualFinalEventStep",
    hebrewDate: "virtualFinalEventStepHebrewDate",
    icon: iconsList.finalEvent
  },
};